import React, { useEffect, useState, useRef,useCallback } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { HasPermission } from "Core/security"
// Actions
// Components
import { Grid, Container,Icon } from "@mui/material";
import { accountSearchWebHooks } from "./redux/slice";
import { usePaggination } from "../../../../core/hooks";
import CreateEditWebhook  from "./components/createEditWebhook";
import LogWebHooks from "./modals/logWebhook";
import DeleteWebHooks  from "./modals/delete";
import { TableButtons } from 'Components/uiControls/Table';
import HistoryIcon from '@mui/icons-material/Warning';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import {
  TableView,
  MenuComponent,
  SearchInput,
  Pill
} from "@gpstrackit/gtc-react-controls";

import { Table, Toolbar, Button } from "Components/uiControls";
import { Tooltip } from 'Components';


import {
  openModalCreateEditWebhook,
  openModalDeleteWebhook,
  openModalLogWebhook
} from 'Redux/actions';

const WebHooks = (props) => {
  // Props
  const { showTable } = props;
  //Hooks
  const { messages, locale } = useIntl();
  const dispatch = useDispatch();
  const { webHooks, loading } = useSelector((state) => state.accountWebHooksRedux);
  const user = useSelector((state) => state.securityRedux.user);

  // Permissions
  const editablePermissions = HasPermission(user, "", [335])

  const tableRef = useRef();
  const pagination = usePaggination(null, null, true, tableRef);
  const [selectedItems, setSelectedItems] = useState([]);

  const optionsSelect = [
    { id: 'SystemAlertLog', name: messages["accountWebHooks_typeCatalog_SystemAlert"] },
    { id: 'DeviceReading', name: messages["accountWebHooks_typeCatalog_LastReading"]  },
    { id: 'Driver', name: messages["accountWebHooks_typeCatalog_Driver"]  },
    { id: 'Unit', name: messages["accountWebHooks_typeCatalog_Unit"]  },
    { id: 'VehicleInformation', name: messages["accountWebHooks_typeCatalog_VehicleInformation"]  },
    { id: 'WorkOrder', name: messages["accountWebHooks_typeCatalog_WorkOrder"]  }
  ];

  useEffect(() => {
    dispatch(accountSearchWebHooks({}));
  }, []);

  useEffect(() => {
    pagination.setColumns([
      {
        key: "name",
        title: messages["accountWebHooks_name"],
        show: true,
        export: true,
        sort: false,
        width: 150,
        render: (row) => {
          return (
            <Grid container alignItems="center">
              <Grid item xs={9} >
                {row.name}
              </Grid>
              {editablePermissions &&
                <Grid item xs={3}>
                  <MenuComponent
                    disabled={loading}
                    options={[messages["edit"], messages["delete"]]}
                    icon="more_vert"
                    className="showInHover"
                    onClick={(d) => {
                      if(d===messages["edit"]){
                        dispatch(openModalCreateEditWebhook({ open: true,data:row }))
                    }else{
                      dispatch(openModalDeleteWebhook({ open: true,data:[row] }))
                    }
                  }}
                  value={row}
                />
              </Grid>
            }
            </Grid>
          );
        },
        functionString: "return row?.name",
      },
      {
        key: "url",
        title: messages["accountWebHooks_url"],
        show: true,
        width: 300,
        sort: false,
        export: true,
        sortValue: (row) => row?.url || "",
        render: (row) => {
          if (!row.url) return <div />;
          return <div>{row.url}</div>;
        },
      },
      {
        key: "catalog",
        title: messages["accountWebHooks_catalog"],
        show: true,
        width: 100,
        sort: false,
        export: true,
        sortValue: (row) => row?.catalog || "",
        render: (row) => {
          if (!row.catalog) return <div />;
          return <div>{row.catalogName}</div>;
        },
      },
      {
        key: "status",
        title: messages["accountWebHooks_status"],
        show: true,
        width: 80,
        sort: true,
        export: true,
        sortValue: (row) => row?.status || "",
        render: (row) => {
          return <Pill key={'pillSt'+row?.id} item={{id: 1,label: row.status==1?messages["dynamicFormsMain_active"]:messages["dynamicFormsDesign_inactive"],color: row.status==1?"default-green":"default"}} />
        },
      },
      {
        key: "latestevents",
        title: messages["accountWebHooks_Latestevents"],
        show: true,
        width: 80,
        sort: false,
        export: false,
        sortValue: (row) => row?.status || "",
        render: (row) => {

          let errorOcurrences = (row?.webhookLog?.error / row?.webhookLog?.occurrences) * 100;
          let messageError = parseFloat(errorOcurrences).toFixed(2) == "NaN"?messages["accountWebHooks_NoInvocationsYet"]:`${messages["accountWebHooks_ErrorandSuccessRate"]} (${parseFloat(errorOcurrences).toFixed(2)}%)`

          return  <Tooltip title={`${messageError}`} placement={'top'}>
                   {
                    errorOcurrences >=10 &&
                      <HistoryIcon  color="warning" sx={{ ml: 1 }} onClick={(d) => {dispatch(openModalLogWebhook({ open: true,data:row }))}} />
                   } 

                  {
                    errorOcurrences <10 &&
                    <CheckCircleIcon  color="success" sx={{ ml: 1 }} onClick={(d) => {dispatch(openModalLogWebhook({ open: true,data:row }))}} />
                   } 
                  </Tooltip>
        },
      },
      
    ]);
  }, [locale]);




  useEffect(() => {
    if (webHooks?.items) {
      const dataAll = webHooks?.items.map(i => ({...i, catalogName: optionsSelect?.find((t) => t.id == i?.catalog)?.name}))
      pagination.onChangeData(dataAll);
    }
  }, [webHooks,locale]);

  const getDataToExport = () => {
    let values = []
    let allData = pagination?.allData
    if (allData) {
        allData.forEach((item) => {
          let catalog = optionsSelect.find((t) => t.id == item?.catalog)?.name
          let active= item?.status==1?messages["dynamicFormsMain_active"]:messages["dynamicFormsDesign_inactive"]
          values.push([item.name, item.url, catalog, active ])
        })
    }
    return values
}

  const getData = useCallback(() => {
    tableRef?.current?.setSelectedItems([]);
    setSelectedItems([])
    setTimeout(()=>{pagination.onSearchChange("")},200)

  })

  return (
    <Container maxWidth={false} style={{paddingTop:0}}>
        <Grid container direction="row" justifyContent="center" alignItems="center">
            <Grid item  sm={4} style={{ display: "flex" }}>
                <Pill key={'pillKey1'} item={{id: 1,label: messages["permissions_apiKeys"],color: "default"}} variant={"filled"} onClick={() => showTable("apiKeys")}/>
                <Pill key={'pillKey2'} item={{id: 2,label: messages["accountWebHooks_webhooks"],color: "default-green"}}  variant={"filled"}  onClick={() => showTable("webHooks")}/>
            </Grid>
        </Grid>

      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Toolbar>
          <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
          >
            {editablePermissions &&
              <>
                <Grid item>
                  <div style={{ marginLeft: 6 }}>
                    <Button
                      type="icon"
                      icon="add_box"
                      placement="bottom"
                      tooltip={messages["add"]}
                      onClick={(e) => {
                        if (e) e?.preventDefault();
                        dispatch(openModalCreateEditWebhook({ open: true, data: {} }))
                      }}
                    />
                  </div>
                </Grid>
                <Grid item>
                  <Button
                    type="icon"
                    icon="delete"
                    placement="bottom"
                    tooltip={messages["delete"]}
                    disabled={!selectedItems?.length}
                    onClick={(e) => {
                      dispatch(openModalDeleteWebhook({ open: true, data: selectedItems }))
                    }}
                  />
                </Grid>
              </>
            }
            <Grid item>
              <TableButtons
                  tableRef={tableRef}
                  messages={messages}
                  buttons={['export']}
                  onExport={(type) => {
                    if (type === "Csv") {
                      tableRef.current.exportCSV();
                    } else if (type === "Pdf") {
                      tableRef.current.exportPDF();
                    }
                  }}
                />
            </Grid>
          </Grid>
        </Toolbar>
        <Grid item xs={12} sm={6} className="mb-10 text-right">
          <SearchInput
            placeholder={messages["search"]}
            searchText={pagination.searchText}
            isDisabled={loading}
            onSearchText={pagination.onSearchChange}
          />
        </Grid>
      </Grid>

      <TableView
        ref={tableRef}
        {...pagination}
        loading={loading}
        hideDragable
        keyColumn="id"
        hideAllInPagination
        hidePagination
        topheight={235}
        exportName={messages["accountWebHooks_webhooks"]}
        exportOrientation="landscape"
        getDataToExport={(data) => getDataToExport(data)}
        onSelectedItems={(items) => setSelectedItems(items)}
      />

      <LogWebHooks getData={getData} />
      <CreateEditWebhook getData={getData} />
      <DeleteWebHooks getData={getData} />
    </Container>
  );
};

export default WebHooks;
